import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { AutoAccidentReport, BaseComponent, FeatureType, Grid, ListItem, ModalSize, User } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { AutoAccidentReportComponent } from './auto-accident-report.component'

@Component({
    selector: 'app-auto-accident-reports',
    templateUrl: './auto-accident-reports.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class AutoAccidentReportsComponent extends BaseComponent {
    public grid: Grid<AutoAccidentReport>

    reportedByMap!: DataMap

    activeUserList: ListItem<string>[] = []

    get currentUserId(): string {
        return this.services.authentication.userId()
    }

    constructor() {
        super()
        this.grid = new Grid<AutoAccidentReport>(this.services)
            .setupModalEditing(
                this.services.data.autoAccidentReports,
                'Auto Accident Report',
                AutoAccidentReportComponent,
                () => AutoAccidentReport.createNew(),
                this,
                ModalSize.extraLarge,
            )
            .wrapColumnHeaders()
            .filterBy(item => [
                item.location,
                item.reportedByName,
                item.departmentInvolved,
                item.vehicleOrEquipmentNumber,
                item.dotClassification,
                item.foremanSuperintendent,
            ])
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.users.queryAllByAction('GetForLookup'),
                    this.services.data.autoAccidentReports.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()

                        const allUsers = result[0] as User[]
                        this.reportedByMap = new DataMap(allUsers, 'id', 'displayName')
                        this.activeUserList = allUsers.filter(u => u.active).map(u => new ListItem(u.id, u.displayName))

                        const items = result[1] as AutoAccidentReport[]
                        this.assignReportedByNames(items, allUsers)
                        this.grid.items = items
                    },
                }),
        )
    }

    private assignReportedByNames(items: AutoAccidentReport[], allUsers: User[]) {
        const nameById = new Map(allUsers.map(u => [u.id, u.displayName]))
        for (const item of items) {
            if (!item.reportedByName && item.reportedByUserId) {
                item.reportedByName = nameById.get(item.reportedByUserId) ?? ''
            }
        }
    }

    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.SafetyAutoAccidentReportEdit])
    }
}
